/* istanbul ignore file */
// TODO: ^ ignore coverage on this file until we can have app test scaffolding ready
import React, { useState, useEffect, useMemo } from 'react'
import { connect } from 'react-redux'
import { CurriculumRouteContentGetter as RouteContentGetter } from 'layers/content/v3/Hocs/CurriculumRouteContentGetter'
import withApiError from 'layers/errorHandling/apiError'
import withSiteContext from 'layers/content/v2/Hocs/withSiteContext'
import HsResourceLibrary from '../component'
import {
  HIGH_SCHOOL_INDIVIDUAL_RESOURCE_PATH,
  isPreviewMode,
} from 'utils/highschoolHelpers'
import { getWorker } from 'mocks/browser'
import algoliasearch from 'algoliasearch'
import searchInsights from 'search-insights'

import {
  ALGOLIA_APP_NAME,
  ALGOLIA_API_KEY,
  ALGOLIA_INDEX_NAME,
} from 'config/env'

import {
  DEFAULT_SEARCHBOX_PLACEHOLDER,
  DEFAULT_SEARCHBOX_TITLE,
} from '../constants'
import {
  shouldUseMockServiceWorker,
  getAlgoliaCacheSettings,
  generateCompletionStatusMap,
  buildFacetFilters,
  loadAlgoliaIndexSettings,
} from '../helpers'
import { userSegmentationBuilder } from 'utils/userSegmentationHelpers'
import {
  AI_HS_PAGE_USAGE_KEY,
  sendApplicationInsightsEvent,
} from 'utils/sendAnalyticsDataHelpers'
import { RouteContentProductAppMap } from 'utils/routing/routeProductMaps'
import { selectors as lmsSelectors } from 'store/lmsManager'

export const HsResourceLibraryContainer = props => {
  useEffect(() => {
    if (shouldUseMockServiceWorker(window.location)) {
      getWorker().catch(error => {
        console.error('Failed to initialize MSW worker:', error)
      })
    }
  }, [])

  const {
    navigationEvent,
    userSegmentationInfo,
    routeContent,
    instructorData,
  } = props || {}

  const { content = {}, loading } = routeContent

  const { resourceLibraryPage } = content

  const readyToLoad =
    !!content && !loading && (!!instructorData || isPreviewMode())

  const searchClient = useMemo(
    () =>
      algoliasearch(ALGOLIA_APP_NAME, ALGOLIA_API_KEY, {
        ...getAlgoliaCacheSettings(ALGOLIA_APP_NAME),
      }),
    [],
  )

  const searchIndex = useMemo(
    () => searchClient.initIndex(ALGOLIA_INDEX_NAME),
    [searchClient],
  )

  const [facetsFilters, setFacetsFilters] = useState([])
  const [settings, setSettings] = useState(null)
  const [isHsPreviewMode, setIsHsPreviewMode] = useState(false)

  useEffect(() => {
    searchInsights('init', {
      appId: ALGOLIA_APP_NAME,
      apiKey: ALGOLIA_API_KEY,
      partial: true,
      useCookie: true,
    })
  }, [])

  useEffect(() => {
    let shouldGetSettings = true
    loadAlgoliaIndexSettings(searchIndex).then(indexSettings => {
      if (!shouldGetSettings) return
      setSettings(indexSettings)
      setFacetsFilters(buildFacetFilters(indexSettings, resourceLibraryPage))
      setIsHsPreviewMode(isPreviewMode())
    })
    return () => {
      shouldGetSettings = false
    }
  }, [searchIndex, resourceLibraryPage])

  useEffect(() => {
    sendApplicationInsightsEvent(AI_HS_PAGE_USAGE_KEY, userSegmentationInfo)
  }, [userSegmentationInfo])

  const completionStatuses = useMemo(() => {
    return instructorData ? generateCompletionStatusMap(instructorData) : {}
  }, [instructorData])

  const onCardClick = routeSlug => {
    if (!routeSlug) return
    const searchParams = window.location.search
    navigationEvent &&
      navigationEvent(
        `${HIGH_SCHOOL_INDIVIDUAL_RESOURCE_PATH}/${routeSlug}${searchParams}`,
      )
  }

  return (
    settings &&
    readyToLoad && (
      <HsResourceLibrary
        {...mapAdditionalProps(resourceLibraryPage)}
        completionStatuses={completionStatuses}
        facetsFilters={facetsFilters}
        isPreview={isHsPreviewMode}
        onCardClick={onCardClick}
        searchClient={searchClient}
      />
    )
  )
}
const options = {
  app: RouteContentProductAppMap.learnHsProduct,
  routeResolver: () => window?.location?.pathname,
}
const mapAdditionalProps = content => ({
  breadcrumb: content?.breadcrumb,
  noResultsText: content?.noResult,
  description: content?.description,
  searchboxPlaceHolder:
    content?.searchPlaceholder || DEFAULT_SEARCHBOX_PLACEHOLDER,
  searchboxTitle: content?.searchTitle || DEFAULT_SEARCHBOX_TITLE,
})

const mapStateToProps = state => ({
  userSegmentationInfo: userSegmentationBuilder(state),
  instructorData: lmsSelectors.selectHsInstructorData(state),
})

const HydratedComponent = connect(mapStateToProps)(HsResourceLibraryContainer)

export default withSiteContext(
  RouteContentGetter(withApiError(HydratedComponent), options),
)
